let language = (window.navigator.language || navigator.browserLanguage).split('-', 1);
    language = language.toString().toUpperCase();
const $selectorLanguage = document.getElementById("gtranslate_selector");
const $regionLanguage = document.querySelector(".region-language");

$regionLanguage.style.setProperty("--content-pseudo", "\'" + language +"\'");

document.addEventListener("input", (e) => {
    if (e.target === $selectorLanguage ) {
      let language = ($selectorLanguage .value === 'es|es') ? "ES" : "EN";
      $regionLanguage.style.setProperty("--content-pseudo", "\'" + language +"\'");
    }
});


